import { styled } from '@mui/material/styles';
import { Box, Typography, Paper, Radio, RadioGroup, FormControlLabel, Link, Button } from '@mui/material';

export const MainContainer = styled(Box)`
  background-color: #fff;
  min-height: 100vh;
  padding-bottom: 64px;
  overflow: auto;
`;

export const ContentContainer = styled(Box)`
  max-width: 800px;
  margin: 0 auto;
  padding: 16px;
  padding-top: 32px;
  padding-bottom: 100px;
`;

export const PageTitle = styled(Typography)`
  font-weight: bold;
  color: var(--primary-blue);
  margin-bottom: 24px;
  text-align: center;
`;

export const VersionContainer = styled(Box)`
  margin-bottom: 32px;
`;

export const IntroText = styled(Typography)`
  margin-bottom: 24px;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
`;

export const VersionPaper = styled(Paper)`
  padding: 24px;
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid #e0e0e0;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const VersionHeader = styled(Box)`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  margin-right: 0;
`;

export const StyledRadio = styled(Radio)`
  color: var(--primary-blue);
  &.Mui-checked {
    color: var(--primary-blue);
  }
`;

export const VersionTitleContainer = styled(Box)``;

export const VersionTitle = styled(Typography)`
  font-weight: bold;
  color: var(--primary-blue);
  font-size: 1rem;
`;

export const VersionContent = styled(Typography)`
  margin-top: 16px;
  padding: 16px;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 32px;
  margin-bottom: 32px;
  width: 100%;
`;

export const ContinueButton = styled(Button)`
  border-radius: 50px;
  padding: 12px 32px;
  background-color: var(--primary-blue);
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1rem;
  box-shadow: 0 3px 5px rgba(0,0,0,0.2);
  
  &:hover {
    background-color: var(--primary-blue);
    opacity: 0.9;
  }
`;

export const BackButton = styled(Button)`
  color: var(--primary-blue);
  text-decoration: none;
  font-weight: 500;
  text-transform: none;
  
  &:hover {
    text-decoration: underline;
    background-color: transparent;
  }
`;

export const FooterContainer = styled(Box)`
  margin-top: 24px;
  text-align: center;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 64px;
`;

export const FooterText = styled(Typography)``;

export const FooterLink = styled(Link)`
  color: var(--primary-blue);
`;

// Converted from SCSS module
export const AddPositionButton = styled(Box)`
  flex-direction: row !important;
`;

export const AddIcon = styled(Box)`
  height: 1.5rem;
`;

export const DatePickers = styled(Box)`
  gap: 1rem;
`;

export const Position = styled(Box)`
  border-radius: 8px;
  border: 1px solid #C4C4C4;
  display: flex;
  padding: 16px;
  align-items: flex-start;
  gap: 8px;
  justify-content: space-between;
`;

export const PositionBox = styled(Box)`
  width: 100%;
  cursor: pointer;
`;

export const PositionTitle = styled(Typography)`
  color: rgba(0, 0, 0, 0.87);
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0.15px;
`;

export const PositionCompany = styled(Typography)`
  color: rgba(0, 0, 0, 0.60);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
`;

export const PositionDates = styled(Typography)`
  color: rgba(0, 0, 0, 0.60);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 166%;
  letter-spacing: 0.4px;
`;

export const DeleteIcon = styled(Box)`
  margin: 0.5rem;
  color: #666666;
  cursor: pointer;
`;

export const HeaderText = styled(Typography)`
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: bold;
  line-height: 150%;
  letter-spacing: 0.15px;
  margin-bottom: 0.5rem;
`;

export const HelpText = styled(Box)`
  color: #00000099;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 100;
  line-height: 166%;
  letter-spacing: 0.4px;
  padding-bottom: 0.5rem;
`;

export const HelpTextSubtitle = styled(Typography)`
  color: #000;
`;

export const InfoText = styled(Typography)`
  color: rgba(0, 0, 0, 0.60);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 166%;
  letter-spacing: 0.4px;
`;

export const InfoIcon = styled(Box)`
  margin-left: 1rem;
  color: rgba(0, 0, 0, 0.60);
`;

export const FooterNote = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.75rem;
  margin-bottom: 1rem;
  color: #00000061;
`;

export const ScreenError = styled(Box)`
  display: block;
  color: #D32F2F;
  text-align: start;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.15px;
  min-height: 2rem;
  margin-bottom: 1rem;
`;

export const NoScreenError = styled(Box)`
  display: none;
`;

export const FooterChooseBio = styled(Box)`
  display: flex;
  align-items: end;
  justify-content: end;
  margin-bottom: 1rem;
  flex-direction: column;
`;

export const MinimalBox = styled(Box)`
  background: var(--common-white-main, #fff);
  border: 1px solid var(--primary-blue, #0B4598);
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  border-radius: 8px;
  padding: 1rem 1rem 0.5rem 1rem;
  margin-bottom: 1rem;
`;

export const ExtraFlairBox = styled(Box)`
  background: #F1F7FF;
  border-radius: 8px;
  padding: 1rem 1rem 0.5rem 1rem;
  margin-bottom: 1rem;
`;

export const BioRadioGroup = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: start;
`;

export const TitleContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.75rem;
  text-align: center;
`;

export const PopupTitle = styled(Typography)`
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: 1.4;
  font-weight: 600;
`;

export const CrossButtonDark = styled(Box)`
  top: 0;
  bottom: 0;
  right: 0;
  position: relative;
`;

export const Description = styled(Typography)`
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
`;

export const ResponseText = styled(Typography)`
  display: flex;
  padding: 0.75rem;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
`;

export const OkButton = styled(Button)`
  color: #FB7672;
  border-color: #FB767280;
`;

export const StyledFooterText = styled(Typography)`
  font-size: 0.75rem;
  color: var(--secondary-main);
  padding-top: 0.3rem;
  text-align: center;
`;

export const StyledFooterLink = styled(Link)`
  text-decoration: underline;
  font-weight: 700;
`; 